//Libs
import React from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';

/**
 * Exibe um botão que permite mostrar um ícone de carregamento
 * @param {Object} props Propriedades do componente
 * @param {*} props.component Componente a ser renderizado
 * @param {Boolean} props.loading Indica se o componente irá mostrar o ícone de carregamento
 * @param {*} props.children Corpo do componente quando não estiver carregando
 */
function LoadingButton({ component, loading, children, ...props }) {
    const ComponentProp = component;
    return (
        <ComponentProp disabled={loading} {...props}>{ loading && <CircularProgress size={25} color="secondary" /> }{ !loading && children }</ComponentProp>
    );
}

LoadingButton.propTypes = {
    /** Componente a ser renderizado */
    component: PropTypes.any,
    /** Indica se o componente irá mostrar o ícone de carregamento */
    loading: PropTypes.bool,
    /** Corpo do componente quando não estiver carregando */
    children: PropTypes.any
};

LoadingButton.defaultProps = {
    loading: false,
    component: Button
};

export default LoadingButton;
